import Cookies from 'js-cookie'

const TokenKey = 'Admin-Token'

export function getToken () {
  return Cookies.get(TokenKey)
}

export function setToken (token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken () {
  return Cookies.remove(TokenKey)
}

export function getAccount () {
  return Cookies.get('account')
}

export function setAccount (account) {
  return Cookies.set('account', account)
}

export function removeAccount () {
  return Cookies.remove('account')
}

export function getCookie (name) {
  return Cookies.get(name)
}

export function setCookie (key, value) {
  var cookietime = new Date(new Date().getTime() + 1000 * 60 * 60 * 12) // 12小时过期时间
  return Cookies.set(key, value, {expires: cookietime})
}

export function removeCookie (key) {
  return Cookies.remove(key)
}
// 设置 localStorage
export function setLocalStorage (key, value) {
  if (!window.localStorage) {
    console.log('浏览器不支持localstorage')
  } else {
    window.localStorage.setItem(key, value)
  }
}
// 读取 localStorage
export function getLocalStorage (key) {
  if (!window.localStorage) {
    console.log('浏览器不支持localstorage')
  } else {
    return window.localStorage.getItem(key)
  }
}

// 清除localStorage
export function removeLocalStorage (key = '') {
  if (!window.localStorage) {
    console.log('浏览器不支持localstorage')
  } else {
    if (key) {
      window.localStorage.removeItem(key)
    } else {
      window.localStorage.clear()
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/auth.js